import React, { Suspense, lazy, useContext, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { StateContext } from "../components/context/ManageStates";
// import { RightCarousel, SmallComp, TitleHeader,Related_Posts,HomeCardSingleBlogs } from '../components/common'
import { FaUser, FaChevronCircleRight } from "react-icons/fa";
import { GiTimeBomb } from "react-icons/gi";
import { NavLink } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import DetailAction from "../redux/actions/DetailAction";
import RelatedAction from '../redux/actions/RelatedAction';
import { useSelector } from 'react-redux';
import useApidata from '../hooks/useApidata';

const HomeCardSingleBlogs = lazy(() => import("../components/common/HomeCardSingleBlogs"));
const SmallComp = lazy(() => import("../components/common/SmallComp"));
const TitleHeader = lazy(() => import("../components/common/TitleHeader"));


const Detail = () => {
    const { useBlogDetail, useRelatedBlogs } = useApidata()

    const { getdetaillistdata } = DetailAction()
    const { getRelatedPostslistdata } = RelatedAction();
    const populardata = useSelector(state => state.masterdata.populardata);
    // const { selectedcategory ,setSelectedcategory} = useContext(StateContext);
    const { slug } = useParams();
    const dispatch = useDispatch();
    const { data, isLoading } = useBlogDetail(slug)
    const { data: relatedData, isLoading: isRelatedLoading } = useRelatedBlogs(data?.data?.data[0]?.category_id)

    const html = data?.data?.data[0]?.post_body?.replace('sandbox=""', '');
    console.log("detail:", data?.data?.data[0]?.category_id)
    console.log("realated blogs:", relatedData?.data?.data?.searchResult)
    // useEffect(() => {

    //     dispatch({
    //         type: 'satDeataidata',
    //         payload: []

    //     });
    //     const input_data = {
    //         slug: slug,

    //     };
    //     dispatch(getdetaillistdata(input_data));
    //     dispatch(getRelatedPostslistdata(input_data));
    // }, [slug])



    // useEffect (()=>{
    //     setSelectedcategory(selectedcategory);
    // },[selectedcategory]);
    return (
        <>
            {data
                //  && detaildata[0].length > 0
                ?

                <Row>
                    <Col lg={12} md={12}>
                        {
                            data?.data?.data[0] &&
                            <div className='detailpage'>
                                <div className='imagecard-absolute imagecard-side detailpage-header-title '>
                                    <div className='ImageCard-category_name'><div className='category_name'>{data?.data?.data[0].category_name}</div></div>
                                </div>
                                <h3 className='detailpage-header-small-discription'>
                                    {data?.data?.data[0].title}
                                </h3>
                                <div className='Singleimage-maindiv '>


                                    {/* <div className='Singleimage-author Singleimage-1  '><FaUser className='Singleimage-author-icon' /> {data[0].authorname}</div> */}


                                    {/* <div className='Singleimage-author '><GiTimeBomb className='Singleimage-author-icon' /> {data[0].createdon}</div> */}


                                </div>
                                {data?.data?.data[0].category_name !== "Videos" && <div className='detail-image-div'>
                                    <img referrerPolicy="no-referrer" className='detail-image' src={`https://cdn.nurexify.com` + data?.data?.data[0].post_images?.desktop_banner[0]?.original}></img>
                                </div>}

                                <div className='detail-full-discription'>

                                    <div dangerouslySetInnerHTML={{ __html: html }} />


                                    {/* <p className='detail-full-discription-span'>
                            Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text ever since when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                        </p> */}
                                    {/* <blockquote  >
                            Lorem Ipsum is simply dummy text of the printing and type setting industry. Lorem Ipsum has been the industry's standard dummy text ever since when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                            </blockquote> */}
                                    {/* <div className='detail-page-points'>
                            <div>
                                <FaChevronCircleRight className='page-details-list-icons' />
                                <span className='page-details-list'>
                                    Lorem Ipsum is simply dummy text of the printing.
                                </span>
                            </div>
                            <div>
                                <FaChevronCircleRight className='page-details-list-icons' />
                                <span className='page-details-list'>
                                    Lorem Ipsum is simply dummy text of the printing.
                                </span>
                            </div>
                            <div>
                                <FaChevronCircleRight className='page-details-list-icons' />
                                <span className='page-details-list'>
                                    Lorem Ipsum is simply dummy text of the printing.
                                </span>
                            </div>
                        </div> */}
                                </div>


                            </div>
                        }




                    </Col>
                    {/* <Col lg={4} md={12}>
                <Suspense>
                <div><TitleHeader title={"TRENDING NEWS"} /></div>
                </Suspense>
                <>
                {
                    populardata && populardata.length>0 &&
                    populardata.map(ele=>{
                        return(
                            <Suspense>
                                <NavLink to={`/detail/${ele.slug}`} className="text-decoration-none" >
                            <div className='HomeCardSingleImagewithBlogs-smallcomp'> <SmallComp className={'HomeCardSingleImagewithBlogs-category '} auth_date={"smallcomp_author_date"}  image={ele.bannerimage} published_date={ele.publishedon} category_name={ele.category_name} discription={ele.title} /></div>
                            </NavLink>
                            </Suspense>
                        
                        )
                    })
                }
                </>
              
            </Col> */}

                    <div className='related-posts'>
                        <Suspense>
                            {/* <Related_Posts/> */}
                            <div><TitleHeader title={"related POSTS"} /></div>
                            <HomeCardSingleBlogs className={"Detailpage"} data={relatedData?.data?.data?.searchResult} />
                        </Suspense>
                    </div>
                </Row> : <div className='custom-height'></div>
            }

        </>
    );
};

export default Detail;